import { FilterSearchContext } from 'contexts/FilterSearchContext'
import FilterIcon from 'images/icon/FilterIcon'
import { useDtmAnalytics } from 'hooks/useDtmAnalytics'
import { useContext } from 'react'
import { StyledSearchFilterButton } from './SearchFilterButton.styled'

interface IProps {
  showFilterSearch: boolean
}
export const SearchFilterButton = ({ showFilterSearch }: IProps) => {
  const { setShowSlideOutFilterSearch } = useContext(FilterSearchContext)
  const { userInteraction } = useDtmAnalytics()
  const handlerClickSearch = () => {
    userInteraction('srp searchresults:advancedfilters')
    setShowSlideOutFilterSearch(true)
  }

  return (
    <StyledSearchFilterButton className="filter-icon" show={showFilterSearch} onClick={handlerClickSearch}>
      <FilterIcon />
    </StyledSearchFilterButton>
  )
}
